import { getRgObjectsOfType as U, RG_TYPE as k, roundDecimals as h } from "@project-rouge/rg-core";
import { memo as H, useState as B, useMemo as c, Fragment as x } from "react";
import { getArea as V } from "../../metrics/scalar-metrics/index3.js";
import { getPerimeter as E } from "../../metrics/scalar-metrics/index8.js";
import { getLandCoverage as G } from "../../metrics/scalar-metrics/total-metrics/index30.js";
import { getNetArea as W } from "../../metrics/scalar-metrics/total-metrics/index37.js";
import { getResidentialLevelCount as Y } from "../../metrics/scalar-metrics/total-metrics/index49.js";
import { getDensityHabitableRooms as _ } from "../../metrics/scalar-metrics/total-metrics/index14.js";
import { getDensityUnits as q } from "../../metrics/scalar-metrics/total-metrics/index15.js";
import { getBuildingStoryMetrics as z } from "./index2.js";
import { getStoryMetricsTotals as J } from "./index6.js";
import { sumDistribution as T } from "./index10.js";
import { jsxs as i, jsx as e, Fragment as g } from "react/jsx-runtime";
var L = /* @__PURE__ */ ((n) => (n.All = "All", n.Building = "Building", n.ApartmentDistribution = "Apartment Distribution", n.ApartmentTypeDistribution = "Apartment Type Distribution", n.Site = "Site", n))(L || {}), F = /* @__PURE__ */ ((n) => (n.PerBuilding = "per building", n.PerLevel = "per level", n))(F || {});
const oe = H(function({
  obj: l
}) {
  const [t, a] = B("All"), [d, m] = B("per building"), [o, R] = B(void 0), w = c(() => t !== "Site", [t]), N = c(() => t === "All" ? !1 : t !== "Site" && o !== void 0, [t, o]), D = c(() => U(l, k.Building), [l]), S = c(() => D.map((r) => z(r)), [l]), $ = c(() => J(l), [l]), I = c(() => T(S.flatMap((r) => r.distribution)), [l]), O = c(() => T(S.flatMap((r) => r.specDistribution)), [l]), s = c(() => {
    if (o !== void 0)
      return S[o];
  }, [l, o]), P = c(() => {
    const r = [];
    return r.push({
      name: "site area",
      value: V(l),
      unit: "m\xB2"
    }, {
      name: "net site area",
      value: W(l),
      unit: "m\xB2"
    }, {
      name: "site perimeter",
      value: E(l),
      unit: "m"
    }, {
      name: "max residential level count",
      value: Y(l),
      unit: "unitless"
    }), D.length && r.push({
      name: "land coverage",
      value: G(l),
      unit: "unitless"
    }, {
      name: "unit density",
      value: q(l),
      unit: "no / m\xB2"
    }, {
      name: "habitable rooms density",
      value: _(l),
      unit: "no / m\xB2"
    }), r;
  }, [l]);
  return /* @__PURE__ */ i("div", {
    style: {
      position: "relative",
      left: "60%",
      width: "40%",
      height: "100%",
      padding: "20px",
      overflow: "auto"
    },
    children: [/* @__PURE__ */ e("label", {
      children: "Metric type "
    }), /* @__PURE__ */ e("select", {
      value: t,
      onChange: (r) => a(r.target.value),
      children: Object.values(L).map((r, u) => /* @__PURE__ */ e("option", {
        value: r,
        children: r
      }, u))
    }), w && /* @__PURE__ */ i(g, {
      children: [/* @__PURE__ */ e("br", {}), /* @__PURE__ */ e("label", {
        children: "Select building "
      }), /* @__PURE__ */ i("select", {
        value: o,
        onChange: (r) => R(isNaN(parseInt(r.target.value)) ? void 0 : parseInt(r.target.value)),
        children: [/* @__PURE__ */ e("option", {
          value: "total",
          children: "Total"
        }, void 0), D.map((r, u) => /* @__PURE__ */ e("option", {
          value: u,
          children: `${u}: ${r.uuid}`
        }, u))]
      })]
    }), N && /* @__PURE__ */ i(g, {
      children: [/* @__PURE__ */ e("br", {}), /* @__PURE__ */ e("label", {
        children: "Metrics displayed "
      }), /* @__PURE__ */ e("select", {
        value: d,
        onChange: (r) => m(r.target.value),
        children: Object.values(F).map((r, u) => /* @__PURE__ */ e("option", {
          value: r,
          children: r
        }, u))
      })]
    }), /* @__PURE__ */ i("h2", {
      children: [t, " Metrics"]
    }), (t === "All" || t === "Site") && M(P, "Site Metrics"), o === void 0 && /* @__PURE__ */ i(g, {
      children: [(t === "All" || t === "Building") && M($, "Total Building Metrics"), (t === "All" || t === "Apartment Distribution") && b(I, "Total Apartment Distribution Metrics"), (t === "All" || t === "Apartment Type Distribution") && b(O, "Total Spec. Distribution Metrics")]
    }), s && /* @__PURE__ */ i(g, {
      children: [(t === "All" || t === "Building" && d === "per building") && M(s.metrics, "Building Metrics"), (t === "All" || t === "Building" && d === "per level") && K(s.levelMetrics), (t === "All" || t === "Apartment Distribution" && d === "per building") && b(s.distribution, "Apartment"), (t === "All" || t === "Apartment Distribution" && d === "per level") && C(s.levelDistribution, "Apartment"), (t === "All" || t === "Apartment Type Distribution" && d === "per building") && b(s.specDistribution, "Spec."), (t === "All" || t === "Apartment Type Distribution" && d === "per level") && C(s.levelSpecDistribution, "Spec.")]
    })]
  });
}), v = {
  width: "100%",
  borderCollapse: "collapse"
}, y = {
  fontWeight: "bold",
  padding: "8px",
  textAlign: "left"
}, f = {
  border: "1px solid #353535",
  textAlign: "left",
  padding: "4px"
}, p = {
  border: "1px solid #353535",
  textAlign: "left",
  padding: "4px"
};
function A(n) {
  return n % 2 === 0 ? {
    backgroundColor: "#bbbbbbbb"
  } : {
    backgroundColor: "#ffffffbb"
  };
}
function M(n, l) {
  return /* @__PURE__ */ i("table", {
    style: v,
    children: [/* @__PURE__ */ e("caption", {
      style: y,
      children: l
    }), /* @__PURE__ */ i("tbody", {
      style: f,
      children: [/* @__PURE__ */ i("tr", {
        style: p,
        children: [/* @__PURE__ */ e("th", {
          children: "Metric"
        }), /* @__PURE__ */ e("th", {
          children: "Value"
        }), /* @__PURE__ */ e("th", {
          children: "Unit"
        })]
      }), n.map((t, a) => /* @__PURE__ */ i("tr", {
        style: A(a),
        children: [/* @__PURE__ */ e("td", {
          children: t.name
        }), /* @__PURE__ */ e("td", {
          children: h(t.value, 2)
        }), /* @__PURE__ */ e("td", {
          children: t.unit
        })]
      }, a))]
    })]
  });
}
function K(n) {
  return /* @__PURE__ */ i("table", {
    style: v,
    children: [/* @__PURE__ */ e("caption", {
      style: y,
      children: "Building level metrics"
    }), /* @__PURE__ */ i("tbody", {
      style: f,
      children: [/* @__PURE__ */ i("tr", {
        style: p,
        children: [/* @__PURE__ */ e("th", {
          children: "Metric"
        }), /* @__PURE__ */ e("th", {
          children: "Value"
        }), /* @__PURE__ */ e("th", {
          children: "Unit"
        })]
      }), n.map((l, t) => /* @__PURE__ */ i(x, {
        children: [/* @__PURE__ */ e("tr", {
          style: p,
          children: /* @__PURE__ */ e("th", {
            colSpan: 3,
            children: `Floor: ${l.floor}`
          })
        }), l.metrics.map((a, d) => /* @__PURE__ */ i("tr", {
          style: A(d),
          children: [/* @__PURE__ */ e("td", {
            children: a.name
          }), /* @__PURE__ */ e("td", {
            children: h(a.value, 2)
          }), /* @__PURE__ */ e("td", {
            children: a.unit
          })]
        }, d))]
      }, t))]
    })]
  });
}
function b(n, l) {
  return /* @__PURE__ */ i("table", {
    style: v,
    children: [/* @__PURE__ */ i("caption", {
      style: y,
      children: [l, " Distribution"]
    }), /* @__PURE__ */ i("tbody", {
      style: f,
      children: [/* @__PURE__ */ i("tr", {
        style: p,
        children: [/* @__PURE__ */ e("th", {
          children: l
        }), /* @__PURE__ */ e("th", {
          children: "Count"
        }), /* @__PURE__ */ e("th", {
          children: "AverageArea"
        }), /* @__PURE__ */ e("th", {
          children: "Ratio"
        })]
      }), n.map((t, a) => /* @__PURE__ */ e(x, {
        children: /* @__PURE__ */ i("tr", {
          style: A(a),
          children: [/* @__PURE__ */ e("td", {
            children: t.name
          }), /* @__PURE__ */ e("td", {
            children: t.count
          }), /* @__PURE__ */ e("td", {
            children: h(t.averageNia, 2)
          }), /* @__PURE__ */ i("td", {
            children: [h(t.ratio * 100, 2), "%"]
          })]
        }, a)
      }, a))]
    })]
  });
}
function C(n, l) {
  return /* @__PURE__ */ i("table", {
    style: v,
    children: [/* @__PURE__ */ i("caption", {
      style: y,
      children: [l, " Distribution by Level"]
    }), /* @__PURE__ */ i("tbody", {
      style: f,
      children: [/* @__PURE__ */ i("tr", {
        style: p,
        children: [/* @__PURE__ */ e("th", {
          children: l
        }), /* @__PURE__ */ e("th", {
          children: "Count"
        }), /* @__PURE__ */ e("th", {
          children: "AverageArea"
        }), /* @__PURE__ */ e("th", {
          children: "Ratio"
        })]
      }), n.map((t, a) => /* @__PURE__ */ i(x, {
        children: [/* @__PURE__ */ e("tr", {
          style: p,
          children: /* @__PURE__ */ e("th", {
            colSpan: 3,
            children: `Distribution on floor: ${t.floor}`
          })
        }), t.mixes.map((d, m) => /* @__PURE__ */ i("tr", {
          style: A(m),
          children: [/* @__PURE__ */ e("td", {
            children: d.name
          }), /* @__PURE__ */ e("td", {
            children: d.count
          }), /* @__PURE__ */ e("td", {
            children: h(d.averageNia, 2)
          }), /* @__PURE__ */ i("td", {
            children: [h(d.ratio * 100, 2), "%"]
          })]
        }, m))]
      }, a))]
    })]
  });
}
export {
  oe as MetricsTableFC
};
//# sourceMappingURL=index9.js.map
